import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

import Footer from '../../components/footer'
import GenreHeader from '../../components/genre-header'
import Header from '../../components/header'
import pageTitleFromPathname from '../../../common/lib/pagetitle-from-pathname'
import Shelves from '../../components/shelves'
import {
	getVideos,
	getVideosRecentlyAdded,
	getVideosRecentlyReleased,
	filterByCollection,
} from '../../../common/contentful'
import Loading from '../../components/loading'

class Genre extends Component {
	constructor(props) {
		super(props)

		const specialCollections = [
			'recently-added',
			'latest-videos',
		]

		this.isSpecialCollection = false

		const {
			params,
		} = this.props.match

		const collectionId = params.id

		this.collectionId = collectionId

		if (specialCollections.includes(this.collectionId)) {
			this.isSpecialCollection = true
		}

		this.state = {
			titles: null
		}
	}

	componentDidMount() {
		this.mounted = true;

		if (this.state.titles === null) {
			if (this.isSpecialCollection) {
				if (this.collectionId === 'recently-added') {
					getVideosRecentlyAdded((entries) => {
						if (this.mounted) {
							this.setState({
								titles: entries,
							})
						}
					})
				} else if (this.collectionId === 'latest-videos') {
					getVideosRecentlyReleased((entries) => {
						if (this.mounted) {
							this.setState({
								titles: entries,
							})
						}
					})
				}
			} else {
				getVideos((entries) => {
					if (this.mounted) {
						this.setState({
							titles: entries,
						})
					}
				})
			}
		}
	}

	componentWillUnmount() {
		this.mounted = false;
  }

	render() {
		let rendered = null

		rendered = (
			<React.Fragment>
				<Header />
				<Loading />
				<Footer />
			</React.Fragment>
		)

		if (this.state.titles !== null) {
			const {
				titles,
			} = this.state

			let name = null
			let videos = null

			if (this.isSpecialCollection) {
				name = pageTitleFromPathname(this.collectionId)
				videos = titles
			} else {
				const filteredVideos = filterByCollection(titles, this.collectionId)

				name = filteredVideos.name
				videos = filteredVideos.videos
			}

			rendered = (
				<React.Fragment>
					<Header />
					<GenreHeader text={name} />
		      <Shelves titles={videos} />
					<Footer />
				</React.Fragment>
			)
		}

		return rendered
	}
}

export default withRouter(Genre)



// WEBPACK FOOTER //
// ./src/desktop/pages/genre/index.js